module.exports = __webpack_public_path__ + "static/media/0520-a-l.a26c98e8.png";